import './Contact.scss';

class Contact {

	constructor(node) {
		this.node = node;
	}

	init() {
		console.log('Contact');
	}

}

if (typeof JSModules === "object") {
	JSModules['Contact'] = Contact;
} else {
	// initialize section
	let section = new Contact;
	section.init();
}

export default Contact;
